module.exports = __webpack_public_path__ + "img/infofoot.b04f1bfe.png";